<div class="pt-5 mx-auto">
  <div class="row">
    <div class="section col-sm-12">
      <div class="separator"></div>
      <!-- page intro start -->
      <!-- this creates a google map on the page with the given lat/lng from -->
      <!-- the component as the initial center of the map: -->
      <!-- <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoomlevel">
      <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
    </agm-map> -->
    <!--  page intro end -->
  </div>
</div>

<div class="row">
  <!-- main content start -->
  <section class="main-content col-sm-8">
    <h1 class="pb-2 border-bottom fw-light" i18n>Kontaktieren Sie uns</h1>
    <p i18n>
        Wenn Sie Fragen, Anregungen oder Kritik haben, dann schreiben Sie uns doch einfach eine
        Nachricht per E-Mail.
      </p>
    <div class="contact-form">
      <form id="contact-form" role="form">
        <div class="name mt-2">
          <label class="form-label" for="name" i18n>Name*</label>
          <input
            required
            type="text"
            [formControl]="emailName"
            class="form-control"
            id="name"
            name="emailname"
            placeholder=""
            />
          @if (emailName.invalid && (emailName.dirty || emailName.touched)) {
            <div
              class="alert alert-danger"
              >
              @if (emailName.errors!['required']) {
                <div i18n>Der Name darf nicht leer sein!</div>
              }
            </div>
          }
        </div>
        <div class="email mt-2">
          <label class="form-label" for="email" i18n>E-Mail*</label>
          <input
            required
            type="email"
            [formControl]="emailAddress"
            class="form-control"
            id="email"
            name="emailadress"
            placeholder=""
            />
          @if (emailAddress.invalid && (emailAddress.dirty || emailAddress.touched)) {
            <div
              class="alert alert-danger"
              >
              @if (emailAddress.errors!['required']) {
                <div i18n>
                Die E-Mail-Adresse darf nicht leer sein!
              </div>
              }
            </div>
          }
        </div>
        <div class="subject mt-2">
          <label class="form-label" for="subject" i18n>Betreff*</label>
          <input
            required
            type="text"
            [formControl]="emailSubject"
            class="form-control"
            id="subject"
            name="emailsubject"
            placeholder=""
            />
          @if (emailSubject.invalid && (emailSubject.dirty || emailSubject.touched)) {
            <div
              class="alert alert-danger"
              >
              @if (emailSubject.errors!['required']) {
                <div i18n>
                Der Betreff darf nicht leer sein!
              </div>
              }
            </div>
          }
        </div>
        <div class="message mt-2">
          <label class="form-label" for="message" i18n>Nachricht*</label>
          <textarea
            required
            class="form-control"
            [formControl]="emailMessage"
            rows="6"
            id="message"
            name="emailmessage"
            placeholder=""
          ></textarea>
          @if (emailMessage.invalid && (emailMessage.dirty || emailMessage.touched)) {
            <div
              class="alert alert-danger"
              >
              @if (emailMessage.errors!['required']) {
                <div i18n>
                Der Nachrichtentext darf nicht leer sein!
              </div>
              }
            </div>
          }
        </div>
        <!-- <re-captcha #recaptchaRef (resolved)="resolved($event)" siteKey=""></re-captcha> -->
        <!-- <input [disabled]="!isResolved" type="button" value="Senden" (click)="send()" class="btn btn-primary mt-2"> -->
        <!-- TODO: reactivate recaptcha in test/prod -->
        <button type="button" [asyncClick]="send.bind(this)" [disabled]="sendBtn.disabled" #sendBtn="asyncClick" class="btn btn-primary mt-2" i18n>
          @if (sendBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Senden
        </button>
      </form>
    </div>
  </section>
  <!-- main content end -->
  <!-- sidebar start -->
  <aside class="sidebar col-sm-4 sidecontactbar">
    <div class="side vertical-divider-left">
      <b class="title" i18n>Kontaktdaten</b>
      <ul class="list">
        <li><strong>teamstep GmbH</strong></li>
        <li>
          <i class="pe-2"> <fa-icon [icon]="faHome"></fa-icon> </i>Frankenstrasse 14<br />46487
          Wesel
        </li>
        <li>
          <i class="pe-2"> <fa-icon [icon]="faPhone"></fa-icon> </i
          ><abbr i18n-title title="Telefon">P:</abbr> +49 0000 00000000
        </li>
      </ul>
      <ul class="list">
        <li><strong i18n>E-Mail</strong></li>
        <li>
          <i class="pe-2"> <fa-icon [icon]="faEnvelope"></fa-icon> </i
          ><a href="mailto:#">info&#64;teamstep-gmbh.de</a>
        </li>
      </ul>
      <ul class="social-links large">
        <li>
          <a target="_blank" href="http://www.facebook.com"
            ><i> <fa-icon [icon]="faFacebook"></fa-icon> </i
          ></a>
        </li>
        <li>
          <a target="_blank" href="http://www.twitter.com"
            ><i> <fa-icon [icon]="faTwitter"></fa-icon> </i
          ></a>
        </li>
        <li>
          <a target="_blank" href="http://plus.google.com"
            ><i> <fa-icon [icon]="faGooglePlus"></fa-icon> </i
          ></a>
        </li>
      </ul>
    </div>
  </aside>
  <!-- sidebar end -->
</div>

<div class="row maps">
  <google-map
    [center]="center"
    [zoom]="zoom"
    width="100%"
    height="300px"
    (mapClick)="moveMap($event)"
    (mapMousemove)="move($event)"
    >
    @for (marker of markers; track marker) {
      <map-marker
        #markerElem="mapMarker"
        [position]="marker.position"
        [label]="marker.label"
        [title]="marker.title"
        [options]="marker.options"
        >
      </map-marker>
    }
  </google-map>
</div>
</div>
